// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__Xh-C2","icon":"Tooltip_icon__6CGCp","multiline":"Tooltip_multiline__sbB8B","message":"Tooltip_message__CSLe7"};